/**
 * Created by shaik on 21/08/16.
 */

define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseFilterViewController = require('web-agent-viewControllers/BaseFilterViewController');
    var FilterItemsFactory = require('web-agent-utils/FilterItemsFactory');

    var Base = BaseFilterViewController;
    var FilterFullTableViewController = Base.extend({
        ControllerName: 'FilterFullTableViewController',
        LPViewMap: {
            filterFieldsArea: '.lpview_filter_container'
        },
        LPClassesMap: {
            listTableContainer: 'list_table_container',
            listItem: 'list_item',
            listItemFilter: 'list_item_filter',
            hidden: 'hidden',
            notHidden: 'not_hidden',
        },
        LPTemplatesFiles: {
            listContainer: 'LP_filter_full_table_listview.html',
            listItem: 'LP_filter_full_table_listview_item.html',
            listItemCollapsible: 'LP_filter_full_table_listview_item_collapsible.html',
            listItemEmptyNameAlignFilterLeft: 'LP_filter_full_table_listview_item_filter_align_left.html'
        },
        LPElementsMap: {
            collapsibleListItem: '.collapsible_list_item'
        },

        initialize: function (constructorData) {
            this.filterName = constructorData.filterName;
            this.tableName = constructorData.tableName;
            this.fields = lpUtils.cloneObject(constructorData.filterFields) || [];
            this.filterItems = {};
            this.filterItemViews = {};
            this.filterItemValidations = {};
            this.containerView = {};
            this.iconCallback = constructorData.iconCallback;
            this.iconContext = constructorData.iconContext;

            if (constructorData.defaultFilter) {
                this.filterResetData = lpUtils.cloneObject(constructorData.defaultFilter);
                this.filterUIData = lpUtils.cloneObject(constructorData.defaultFilter);
                this.filterData = lpUtils.cloneObject(constructorData.defaultFilter);
            }
            this.initializeView();
        },
        events: function () {
        },
        render: function () {
            this.onShow();
        }
    });

    FilterFullTableViewController.prototype.initializeView = function () {
        var filterTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.listContainer);
        // var filterTemplate = lpUtils.loadResource(this.LPTemplatesFiles.listContainer);
        var self = this;

        this.containerView = self.createView({template: filterTemplate, target: this.LPViewMap.filterArea, className: self.LPClassesMap.listTableContainer});

        _.each(self.fields, function(field){
            var filterItem = FilterItemsFactory.getFilterItem(field.type, field, {context: self});
            if(filterItem) {

                self.filterItems[field.name] = filterItem;

                if(field.type=="collapsible") {
                    filterItem.setDisableFilterItemViewCallback(self.disableFilterItemView.bind(self));
                    filterItem.setEnableFilterItemViewCallback(self.enableFilterItemView.bind(self));
                    filterItem.setScrollTopCallback(self.scrollTop.bind(self));
                    filterItem.setScrollBottomCallback(self.scrollBottom.bind(self));
                    filterTemplate = require('web-agent-templates/' + self.LPTemplatesFiles.listItemCollapsible);
                } else{
                    filterTemplate = require('web-agent-templates/' + ((field.type=="singleCheckBox" && field.alignLeft) ? self.LPTemplatesFiles.listItemEmptyNameAlignFilterLeft : self.LPTemplatesFiles.listItem));
                }

                if(field.type=="singleCheckBox" && field.filterItemToEnableWhenChecked) {
                    filterItem.setOnClickAdditionalEvent(self.toggleFilterItem.bind(self, field.filterItemToEnableWhenChecked));
                }

                var textInjection = {
                    item_name: field.text ? self.translate(field.text) + (field.type==="collapsible" ? '' : ':') : '',
                    item_tooltip: field.text ? (field.tooltip ? self.translate(field.tooltip) : self.translate(field.text)) : ''
                };
                filterTemplate = self.injectTextDefaults(filterTemplate, textInjection);
                self.filterItemViews[field.name] = self.createView({template: filterTemplate, target: self.LPViewMap.filterFieldsArea, className: self.LPClassesMap.listItem});
                var filterItemElement = self.filterItemViews[field.name].getElementsByClassName(self.LPClassesMap.listItemFilter)[0];
                self.addClass(self.filterItemViews[field.name], field.hideTableRowOnLoad ? self.LPClassesMap.hidden : self.LPClassesMap.notHidden);

                if(field.type=="collapsible") {
                    self.bindViewEvent({DOMEvent: "click", selector: self.LPElementsMap.collapsibleListItem, callback: self.selectItem.bind(self, field.name)});
                }

                if(field.validateable) {
                    self.filterItemValidations[field.name] = true;
                    filterItem.setValidationFailedHook(self.onFieldValidationFailed.bind(self, field.name));
                    filterItem.setValidationFailureRecoverHook(self.onFieldValidationFailureRecover.bind(self, field.name));
                }

                self.addViewController({viewController: filterItem, target: filterItemElement});
            }
        });
    };

    FilterFullTableViewController.prototype.selectItem = function (fieldName) {
        this.filterItems[fieldName].selectItem();
    };

    FilterFullTableViewController.prototype.onFieldValidationFailed = function (fieldName) {
        this.filterItemValidations[fieldName] = false;
        Base.prototype.disableFilterButton.call(this);
    };

    FilterFullTableViewController.prototype.onFieldValidationFailureRecover = function (fieldName) {
        this.filterItemValidations[fieldName] = true;
        var noValidationFailures = true;
        _.each(this.filterItemValidations, function(valid){
            if(!valid) {
                noValidationFailures = false;
            }
        });
        if(noValidationFailures) {
            Base.prototype.enableFilterButton.call(this);
        }
    };

    FilterFullTableViewController.prototype.scrollTop = function () {
        this.containerView.scrollTop = 0;
    };

    FilterFullTableViewController.prototype.scrollBottom = function () {
        this.containerView.scrollTop = this.containerView.scrollHeight;
    };

    FilterFullTableViewController.prototype.disableFilterItemView = function (itemName) {
        this.removeClass(this.filterItemViews[itemName], this.LPClassesMap.notHidden);
        this.addClass(this.filterItemViews[itemName], this.LPClassesMap.hidden);
    };

    FilterFullTableViewController.prototype.enableFilterItemView = function (itemName) {
        this.removeClass(this.filterItemViews[itemName], this.LPClassesMap.hidden);
        this.addClass(this.filterItemViews[itemName], this.LPClassesMap.notHidden);
    };

    FilterFullTableViewController.prototype.toggleFilterItem = function (itemName, enable) {
        this.filterItems[itemName].toggleFilterItem(enable);
    };

    /**
     * @override
     */
    FilterFullTableViewController.prototype.lpShow = function (view, parentScope, animate) {
        //as the filter container position is fixed - a height must be set explicitly and not by percentage
        this.containerView.style['max-height'] = (window.innerHeight - 320) + "px"; //remove header and footer height
        BaseFilterViewController.prototype.lpShow.apply(this, arguments);
    };

    FilterFullTableViewController.prototype.submitClick = function () {
        this.arrangeDataToSubmit();
        this.submitFilter();
    };

    FilterFullTableViewController.prototype.arrangeDataToSubmit = function () {
        var self = this;
        var fieldInput;
        _.each(self.filterItems, function(item, name){
            fieldInput = item.getValue();
            self.filterUIData[name] = fieldInput;
        });
    };

    FilterFullTableViewController.prototype.updateFilterUI = function () {
        var self = this;
        _.each(self.fields, function(field) {
            if(field.name && self.filterItems[field.name]){
                var filterInput;
                if(self.filterUIData && self.filterUIData[field.name]) {
                    filterInput = self.filterUIData[field.name];
                }
                self.filterItems[field.name].updateFilterUI(filterInput);
            }
        });
    };

    FilterFullTableViewController.prototype.isFilterSet = function () {
        return true;
    };

    // Check if the user click on one of the buttons (filter/reset/cancel) when closing the dropdown
    FilterFullTableViewController.prototype.onLostFocus = function (e) {
        this.setFocus();
        // Get the src element from the event data
        var src = e.toElement || e.relatedTarget  || e.rangeParent || e.explicitOriginalTarget;
        if (src && src.nodeType === 3) { // 3= Represents textual content in an element or attribute, we need to get it's Element (his parent).
            src = src.parentElement;
        }
        if (this.getFirstElement(this.LPViewMap.filter_button) === src) {
            this.submitClick();
        } else if (this.getFirstElement(this.LPViewMap.reset_button) === src){
            this.reset();
        }  else if (this.getFirstElement(this.LPViewMap.cancel_button) === src){
            this.cancel();
        }
    };


    FilterFullTableViewController.prototype.cancel = function (e) {
        //keep the filter open if user click outside of the filter box
        if(e && (e.type === "blur" || e.type === "focusout")) {
            return;
        }
        Base.prototype.cancel.call(this);
    };


    return FilterFullTableViewController;

});
